let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("579xR")).then(() => parcelRequire('b4Lez'));